export default [
  {
    _name: 'CSidebarNav',
    _children: [        
      {
        _name: 'CSidebarNavTitle',
        _children: ['Currículo']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Currículo',
        to: 'profile',
        icon: 'cilAddressBook'        
      },             
      {
        _name: 'CSidebarNavItem',
        name: 'Atualizar Dados',
        to: 'editar',
        icon: 'cilUserFollow'        
      },              
     /*  {
        _name: 'CSidebarNavItem',
        name: 'Notificações',
        to: '#',
        icon: 'cil-bell'        
      },                    */
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Conta']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Definições',
        to: 'definicoes',
        icon: 'cil-settings',        
      },      
    ]
  }
]